if (!customElements.get('smooche-below-atc')) {
  customElements.define('smooche-below-atc', class extends HTMLElement {
    connectedCallback() {
      var root = this;
      this.controller = new AbortController();
      var signal = this.controller.signal;

      function clamp(n, min, max) {
        return Math.min(max, Math.max(min, n));
      }

      function randInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function readStore(key) {
        try {
          var raw = sessionStorage.getItem(key);
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      }

      function writeStore(key, value) {
        try {
          sessionStorage.setItem(key, JSON.stringify(value));
        } catch (e) {}
      }

      var storageKey = root.getAttribute('data-cs-storage-key') || 'cs-urgency';
      var soldRandomize = root.getAttribute('data-cs-sold-randomize') !== 'false';
      var soldMin = parseInt(root.getAttribute('data-cs-sold-min'), 10) || 80;
      var soldMax = parseInt(root.getAttribute('data-cs-sold-max'), 10) || 99;
      var soldFixed = parseInt(root.getAttribute('data-cs-sold-fixed'), 10) || 89;
      var soldSuffix = root.getAttribute('data-cs-sold-suffix') || '';
      var expiry = root.getAttribute('data-cs-timer-expiry') || 'restart';
      var timerMode = root.getAttribute('data-cs-timer-mode') || 'random';
      var timerHMin = parseInt(root.getAttribute('data-cs-timer-h-min'), 10) || 3;
      var timerHMax = parseInt(root.getAttribute('data-cs-timer-h-max'), 10) || 12;
      var timerHFixed = parseInt(root.getAttribute('data-cs-timer-h-fixed'), 10) || 5;

      if (soldMin > soldMax) {
        var tmpSold = soldMin;
        soldMin = soldMax;
        soldMax = tmpSold;
      }
      soldMin = clamp(soldMin, 1, 99);
      soldMax = clamp(soldMax, soldMin, 99);

      if (timerHMin > timerHMax) {
        var tmpH = timerHMin;
        timerHMin = timerHMax;
        timerHMax = tmpH;
      }

      var signature = [soldRandomize, soldMin, soldMax, soldFixed, timerMode, timerHMin, timerHMax, timerHFixed, expiry].join('|');
      var stored = readStore(storageKey) || {};
      if (stored.signature !== signature) stored = {};
      var soldPct;

      if (soldRandomize) {
        if (typeof stored.soldPct === 'number' && stored.soldPct >= soldMin && stored.soldPct <= soldMax) {
          soldPct = stored.soldPct;
        } else {
          soldPct = randInt(soldMin, soldMax);
        }
      } else {
        soldPct = clamp(soldFixed, 1, 99);
      }

      var soldLabel = root.querySelector('[data-cs-sold-label]');
      root.style.setProperty('--cs-sold-pct', soldPct + '%');
      if (soldLabel) soldLabel.textContent = soldPct + soldSuffix;

      var display = root.querySelector('[data-cs-countdown]');
      var endsAt = typeof stored.endsAt === 'number' ? stored.endsAt : 0;
      var now = Date.now();

      function pickNewEndsAt() {
        if (timerMode === 'midnight') {
          var midnight = new Date();
          midnight.setHours(24, 0, 0, 0);
          return midnight.getTime();
        }
        var hours = timerMode === 'fixed' ? timerHFixed : randInt(timerHMin, timerHMax);
        // Add random minutes/seconds so it doesn't always look like :00:00
        var extraMin = timerMode === 'fixed' ? 0 : randInt(0, 59);
        var extraSec = timerMode === 'fixed' ? 0 : randInt(0, 59);
        return Date.now() + hours * 3600000 + extraMin * 60000 + extraSec * 1000;
      }

      if (!endsAt || (endsAt <= now && expiry === 'restart')) {
        endsAt = pickNewEndsAt();
      }

      writeStore(storageKey, { soldPct: soldPct, endsAt: endsAt, signature: signature });

      if (display) {
        function tick() {
          var ms = Math.max(0, endsAt - Date.now());
          if (ms === 0 && expiry === 'restart') {
            endsAt = pickNewEndsAt();
            writeStore(storageKey, { soldPct: soldPct, endsAt: endsAt, signature: signature });
            ms = Math.max(0, endsAt - Date.now());
          }
          if (ms === 0 && expiry === 'hide') {
            var timerRow = root.querySelector('[data-cs-timer]');
            if (timerRow) timerRow.hidden = true;
          }
          var totalSec = Math.floor(ms / 1000);
          var h = Math.floor(totalSec / 3600);
          var m = Math.floor((totalSec % 3600) / 60);
          var s = totalSec % 60;
          display.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
        }
        tick();
        this.timer = setInterval(tick, 1000);
      }

      var items = root.querySelectorAll('.cs-below-atc__faq-item');
      items.forEach(function (item) {
        var btn = item.querySelector('.cs-below-atc__faq-btn');
        var panel = item.querySelector('.cs-below-atc__faq-collapse');
        if (!btn || !panel) return;

        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          if (open) {
            panel.style.height = panel.scrollHeight + 'px';
            panel.offsetHeight;
            panel.style.height = '0px';
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.style.height = panel.scrollHeight + 'px';
            var onEnd = function (e) {
              if (e.propertyName !== 'height') return;
              if (item.classList.contains('is-open')) panel.style.height = 'auto';
              panel.removeEventListener('transitionend', onEnd);
            };
            panel.addEventListener('transitionend', onEnd);
          }
        }, { signal: signal });
      });
      root.addEventListener('shopify:block:select', function(event) {
        var item = event.target.closest('.cs-below-atc__faq-item');
        if (item && !item.classList.contains('is-open')) item.querySelector('button').click();
      }, { signal: signal });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller.abort();
    }
  });
}
